export default "__VITE_ASSET__rTOVBAbseenyPGYLOP0JOQ__"